import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../core/core.store'

export const selectAppState = (state: RootState) => state.app

export const selectCurrency = createSelector(selectAppState, (state) => state.currency)

export const selectDomain = createSelector(selectAppState, (state) => state.domain)
